import { Alert } from '@stone-payments/jade';
import { CustomAlertProps } from './types';

export function CustomAlert({
  description,
  showIcon,
  title,
  variant,
  onDismiss
}: CustomAlertProps) {
  return (
    <Alert
      role='alert'
      description={description}
      showIcon={showIcon}
      title={title}
      variant={variant}
      onDismiss={onDismiss}
    />
  );
}
